import { ObservableArray, View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerSideDataLoader } from "uicomponents";
import { warehouse, WarehouseManipulationViewModel } from "./warehouseManipulation-viewModel"

export class WarehouseManipulationView extends View<WarehouseManipulationViewModel>{
    GetViewUniqueId(): string {
        return "V-17BDA2B5-AEA9-4920-BFC3-04CC3759BC81"
    }
    loadHtml(): string {
        let element = require('./warehouseManipulation.html').default;
        let style = require('./warehouseManipulation.less');
        return element;
    }
    constructor() {
       super();
    }
    
    public set warehouses(v: ObservableArray<warehouse>) { this._warehouses = v; } public get warehouses(): ObservableArray<warehouse> { return this._warehouses;} private _warehouses: ObservableArray<warehouse>;    
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;  

    requestWarehouseCreation(){
        this.dataContext.requestWarehouseCreation();
    }
}
